import Button from "./PrimaryButton";

export default Button;
